<template>
  <div
    class="wrapperPage w-full"
    v-if="dadosProposta.propostas && dadosProposta.propostas.length > 0"
  >
    <div
      v-if="dadosProposta.dataAceite"
      class="row p-2 w-full header-aprove hideInPrintVersion"
    >
      <div class="flex justify-center items-center">
        <vs-icon
          icon-pack="material-icons"
          icon="check_circle"
          color="white"
          size="small"
        />
        <p class="text-white ml-1">PROPOSTA ACEITA</p>
      </div>
    </div>

    <div
      class="pagebreak-inside-avoid"
      v-if="dadosProposta.dadosAssociacao.capaProposta"
    >
      <img
        class="capaImpressao showInPrintVersion pagebreak-inside-avoid"
        :src="dadosProposta.dadosAssociacao.capaProposta"
      />
    </div>

    <div class="container flex">
      <div
        class="logoPlusWpp text-left justify-center w-full flex pt-8 pb-8 sm:justify-between"
      >
        <div class="logo">
          <img
            style="max-height: 200px; max-width: 200px"
            :src="dadosProposta.dadosAssociacao.logo"
            :alt="
              dadosProposta.idEmpresa === empresa.ERP_GERAL
                ? 'Bem Protege'
                : dadosProposta.dadosAssociacao.nome
            "
          />
        </div>
        <div class="boxWpp hidden sm:block">
          <a
            class="hideInPrintVersion"
            target="_blank"
            :href="returnLinkWhatsVendedor(dadosProposta.dadosVendedor.usuario)"
          >
            <div class="whatsAppDiv flex pr-6 pl-3 justify-between fade-in">
              <div>
                <img src="../../assets/images/pages/wpp-icon.png" width="50" />
              </div>
              <div class="wppConsultor pt-1 pb-1 flex">
                <p class="wppTexto text-white">WhatsApp do Corretor</p>
                <p class="wppNumero text-white">
                  {{ dadosProposta.dadosVendedor.telefone }}
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="blueBar pb-5 flex items-center bar-without-video static">
      <div class="container">
        <p class="textBlueBar1">
          Olá {{ dadosProposta.dadosCliente.associado }}. Esta é uma proposta
          para os seus veículos:
        </p>
        <p class="text-2xl mt-2">Id Diversos - #{{ dadosProposta.idFrota }}</p>
      </div>
    </div>

    <div class="container contInfo pb-5">
      <div class="vx-row flex justify-between">
        <div class="blocoInfo collapse-invoice vx-col sm:w-3/5 w-full p-0">
          <vs-collapse>
            <vs-collapse-item
              v-for="proposta in dadosProposta.propostas"
              :key="proposta.idProposta"
              class="item-collapse"
            >
              <div slot="header">
                <h2 class="py-3 titleListItems w-11/12">
                  {{
                    proposta.dadosVeiculo.placa || proposta.dadosVeiculo.chassi
                  }}
                  -
                  {{ proposta.dadosVeiculo.veiculoModelo }}
                </h2>
                <div
                  class="titleListItems w-11/12 flex"
                  v-if="proposta.exibirParticipacaoProposta"
                >
                  <span>Franquia - {{ proposta.valorCotaParticipacao }}%</span>
                  <span v-if="proposta.valorParticipacaoMinimo > 0"
                    >, mínimo de
                    {{ proposta.valorParticipacaoMinimo | currency }}</span
                  >
                </div>
              </div>
              <div class="content rounded-lg">
                <h3 class="pb-5">Este plano inclui as seguintes coberturas</h3>

                <div v-if="proposta.permiteInvoiceSelfService">
                  <div
                    class="produtosBeneficios"
                    v-for="(produto, index) in proposta.produtosObrigatorios"
                    :key="`prod-obrig-${index}`"
                  >
                    <div
                      class="flex items-center justify-between"
                      v-if="produto.produtoVisivel"
                    >
                      <div class="flex nome items-center">
                        <vs-icon
                          icon-pack="material-icons"
                          icon="check"
                          color="green"
                          size="medium"
                        />
                        <span
                          class="listItemsProtecoes ml-3"
                          :style="
                            produto.excluido
                              ? 'text-decoration: line-through;'
                              : ''
                          "
                          >{{ produto.nomeProduto }}</span
                        >
                      </div>
                      <div
                        class="descricao flex"
                        v-if="produto.visivelProposta"
                      >
                        <span
                          v-if="produto.descontoConcedido > 0"
                          :style="'text-decoration: line-through;'"
                          class="valorprod mr-2"
                          >{{ produto.valor | currency }}</span
                        >
                        <span class="listItemsProtecoes">{{
                          produto.valorFinal | currency
                        }}</span>
                      </div>
                    </div>
                    <vs-divider
                      class="mb-1 mt-1"
                      v-if="produto.produtoVisivel"
                    />
                  </div>
                </div>

                <div v-if="!proposta.permiteInvoiceSelfService">
                  <div
                    class="produtosBeneficios"
                    v-for="(produto, index) in proposta.produtosObrigatorios"
                    :key="`prod-obrig2-${index}`"
                  >
                    <div
                      class="flex items-center justify-between"
                      v-if="produto.produtoVisivel && !produto.excluido"
                    >
                      <div class="flex nome items-center">
                        <vs-icon
                          icon-pack="material-icons"
                          icon="check"
                          color="green"
                          size="medium"
                        />
                        <span class="listItemsProtecoes ml-3">{{
                          produto.nomeProduto
                        }}</span>
                      </div>
                      <div
                        class="descricao flex"
                        v-if="produto.visivelProposta"
                      >
                        <span class="listItemsProtecoes">{{
                          produto.valorFinal | currency
                        }}</span>
                      </div>
                    </div>
                    <vs-divider
                      class="mb-1 mt-1"
                      v-if="produto.produtoVisivel && produto.excluido != true"
                    />
                  </div>
                </div>

                <div
                  class="produtosBeneficios"
                  v-for="(beneficio, indexBeneficio) in proposta.beneficios"
                  :key="`prod-benef-${indexBeneficio}`"
                >
                  <div class="flex items-center justify-between">
                    <div class="nome flex items-center">
                      <vs-icon
                        icon-pack="material-icons"
                        icon="check"
                        color="green"
                        size="medium"
                      />
                      <span class="listItemsProtecoes ml-3">{{
                        beneficio.nome
                      }}</span>
                    </div>
                    <div class="descricao flex" v-if="beneficio.descricao">
                      <span class="listItemsProtecoes"
                        >{{ beneficio.descricao }}
                      </span>
                    </div>
                  </div>
                  <vs-divider class="mb-1 mt-1" />
                </div>

                <div v-if="!proposta.permiteInvoiceSelfService">
                  <div
                    class="produtosBeneficios"
                    v-for="(
                      produto, indexProdutoOpcional
                    ) in proposta.produtosOpcionais"
                    :key="`prod-opc-${indexProdutoOpcional}`"
                  >
                    <div
                      class="flex items-center justify-between"
                      v-if="produto.produtoVisivel && produto.selecionado"
                    >
                      <div class="flex nome items-center">
                        <vs-icon
                          icon-pack="material-icons"
                          icon="check"
                          color="green"
                          size="medium"
                        />
                        <span class="listItemsProtecoes ml-3">{{
                          produto.nomeProduto
                        }}</span>
                      </div>
                      <div
                        class="descricao flex"
                        v-if="produto.visivelProposta && produto.selecionado"
                      >
                        <span
                          v-if="produto.descontoConcedido > 0"
                          :style="'text-decoration: line-through;'"
                          class="valorprod mr-2"
                          >{{ produto.valor | currency }}</span
                        >

                        <span class="listItemsProtecoes">{{
                          produto.valorFinal | currency
                        }}</span>
                      </div>
                    </div>
                    <vs-divider
                      class="mb-1 mt-1"
                      v-if="produto.produtoVisivel && produto.selecionado"
                    />
                  </div>
                </div>

                <div
                  v-if="
                    proposta.permiteInvoiceSelfService &&
                    proposta.produtosOpcionais.length > 0
                  "
                  class="pagebreak-inside-avoid"
                  :class="
                    existeProdutoOpcionalVeiculoSelecionado
                      ? null
                      : 'hideInPrintVersion'
                  "
                >
                  <h2 class="pb-3 titleListItems mt-8">Coberturas opcionais</h2>
                  <h3
                    class="pb-5 hideInPrintVersion"
                    v-if="proposta.permiteInvoiceSelfService"
                  >
                    Acrescente serviços opcionais ao seu plano
                  </h3>
                  <h3
                    class="pb-5 showInPrintVersion"
                    v-if="proposta.permiteInvoiceSelfService"
                  >
                    Os serviços opcionais inclusos no seu plano
                  </h3>
                  <div
                    class="opcionais"
                    v-for="(
                      produto, indexProdutoOpcional
                    ) in proposta.produtosOpcionais"
                    :key="`prod-opcin-${indexProdutoOpcional}`"
                    :class="produto.selecionado ? null : 'hideInPrintVersion'"
                  >
                    <div v-if="produto.exibir">
                      <div
                        v-if="proposta.permiteInvoiceSelfService"
                        class="flex items-center justify-between"
                      >
                        <div class="flex w-4/5 items-center">
                          <div>
                            <vs-icon
                              class="showInPrintVersion"
                              icon-pack="material-icons"
                              icon="check"
                              color="green"
                              size="medium"
                            />
                            <vs-switch
                              class="hideInPrintVersion"
                              color="success"
                              v-model="produto.selecionado"
                              :disabled="
                                proposta.idStatus !== statusCotacao.EM_ABERTO &&
                                (propostaVencida ||
                                  !aprovarPropostasVencidas ||
                                  isInterno ||
                                  proposta.dataAceite)
                              "
                              @input="
                                selecionaProduto(
                                  produto,
                                  produto.selecionado,
                                  proposta.idProposta,
                                  proposta,
                                ),
                                  verificaExisteEscolhidoOpcional(
                                    'veiculo',
                                    produto,
                                  )
                              "
                              :key="`prod-opci-${indexProdutoOpcional}-${produto.idProduto}`"
                            >
                              <span slot="on"></span>
                              <span slot="off"></span>
                            </vs-switch>
                          </div>
                          <span class="listItemsOpcionais ml-3">{{
                            produto.nomeProduto
                          }}</span>
                        </div>
                        <span>{{ produto.valorFinal | currency }}</span>
                      </div>
                      <vs-divider class="mb-1 mt-1" />
                    </div>
                  </div>
                </div>

                <div
                  v-if="proposta.agregado"
                  class="mt-8 pagebreak-inside-avoid"
                >
                  <div
                    v-for="(agregado, id) in proposta.agregados"
                    :key="`agreg-${agregado.idPropostaComplemento}-${id}`"
                  >
                    <div class="container contInfo pb-5 mt-2 w-full">
                      <div class="vx-row flex justify-between">
                        <div class="blocoInfo w-full p-5">
                          <h2 class="pb-2 titleListItems">
                            {{ agregado.placa || agregado.chassi }} - #
                            {{ agregado.descricao }}
                          </h2>
                          <div class="flex pb-3 font-semibold">
                            <p>
                              Franquia - {{ agregado.porcentagemParticipacao }}%
                            </p>
                            <p v-if="agregado.valorMinimoParticipacao > 0">
                              , mínimo de
                              {{ agregado.valorMinimoParticipacao | currency }}
                            </p>
                          </div>
                          <h3 class="pb-5">
                            Este plano inclui as seguintes coberturas
                          </h3>
                          <div>
                            <div
                              class="produtosBeneficios"
                              v-for="(
                                produtosObrigatorios, indexProdutoObrigatorio
                              ) in agregado.produtosObrigatorios"
                              :key="`prod-agreg-${indexProdutoObrigatorio}`"
                            >
                              <div
                                class="flex items-center justify-between"
                                v-if="produtosObrigatorios.produtoVisivel"
                              >
                                <div class="flex nome items-center">
                                  <vs-icon
                                    icon-pack="material-icons"
                                    icon="check"
                                    color="green"
                                    size="medium"
                                  />
                                  <span
                                    class="listItemsProtecoes ml-3"
                                    :style="
                                      produtosObrigatorios.excluido
                                        ? 'text-decoration: line-through;'
                                        : ''
                                    "
                                    >{{
                                      produtosObrigatorios.nomeProduto
                                    }}</span
                                  >
                                </div>
                                <div
                                  class="descricao flex"
                                  v-if="produtosObrigatorios.visivelProposta"
                                >
                                  <span
                                    v-if="
                                      produtosObrigatorios.descontoConcedido > 0
                                    "
                                    :style="'text-decoration: line-through;'"
                                    class="valorprod mr-2"
                                    >{{
                                      produtosObrigatorios.valor | currency
                                    }}</span
                                  >
                                  <span class="listItemsProtecoes">{{
                                    produtosObrigatorios.valorFinal | currency
                                  }}</span>
                                </div>
                              </div>
                              <vs-divider
                                class="mb-1 mt-1"
                                v-if="produtosObrigatorios.produtoVisivel"
                              />
                            </div>
                          </div>
                          <div
                            v-if="proposta.permiteInvoiceSelfService"
                            class="pagebreak-inside-avoid"
                            :class="
                              proposta.existeProdutoOpcionalAgregadoSelecionado
                                ? null
                                : 'hideInPrintVersion'
                            "
                          >
                            <h2 class="pb-3 titleListItems mt-8">
                              Coberturas opcionais
                            </h2>

                            <h3 class="pb-5 hideInPrintVersion">
                              Acrescente serviços opcionais ao seu plano
                            </h3>
                            <h3 class="pb-5 showInPrintVersion">
                              Os serviços opcionais inclusos no seu plano
                            </h3>
                            <div
                              class="opcionais"
                              v-for="(
                                produto, indexProdAdicionalAgregado
                              ) in agregado.produtosOpcionais"
                              :key="`prodAgreg-${indexProdAdicionalAgregado}`"
                              :class="
                                produto.selecionado
                                  ? null
                                  : 'hideInPrintVersion'
                              "
                            >
                              <div class="flex items-center justify-between">
                                <div class="flex w-4/5 items-center">
                                  <div>
                                    <vs-icon
                                      class="showInPrintVersion"
                                      icon-pack="material-icons"
                                      icon="check"
                                      color="green"
                                      size="medium"
                                    />
                                    <vs-switch
                                      class="hideInPrintVersion"
                                      color="success"
                                      v-model="produto.selecionado"
                                      @input="
                                        selecionaProdutoAgregado(
                                          produto,
                                          produto.selecionado,
                                          id,
                                          proposta,
                                        ),
                                          verificaExisteEscolhidoOpcional(
                                            'agregado',
                                            produto,
                                          )
                                      "
                                      :key="`prodAgreg-item-${indexProdAdicionalAgregado}`"
                                      :disabled="
                                        proposta.idStatus !==
                                          statusCotacao.EM_ABERTO &&
                                        (propostaVencida ||
                                          !aprovarPropostasVencidas ||
                                          isInterno ||
                                          proposta.dataAceite)
                                      "
                                    >
                                      <span slot="on"></span>
                                      <span slot="off"></span>
                                    </vs-switch>
                                  </div>
                                  <span class="listItemsOpcionais ml-3">{{
                                    produto.nomeProduto
                                  }}</span>
                                </div>
                                <span>{{ produto.valorFinal | currency }}</span>
                              </div>
                              <vs-divider class="mb-1 mt-1" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="proposta.implemento">
                  <div v-if="proposta.implemento">
                    <div
                      v-for="(implemento, indexImplemento) in implementos"
                      :key="`implem-${indexImplemento}`"
                      class="pagebreak-inside-avoid"
                    >
                      <div class="container contInfo pb-5 mt-2">
                        <div class="vx-row flex justify-between">
                          <div class="blocoInfo w-full p-5">
                            <h2 class="pb-3 titleListItems">
                              # {{ implemento.descricao }}
                            </h2>
                            <div class="produtosBeneficios">
                              <div class="flex items-center justify-between">
                                <div class="flex nome items-center">
                                  <vs-icon
                                    icon-pack="material-icons"
                                    icon="check"
                                    color="green"
                                    size="medium"
                                    v-if="implemento.marca || implemento.modelo"
                                  />
                                  <span class="listItemsProtecoes ml-3"
                                    >{{ implemento.marca }}
                                    {{ implemento.modelo }}</span
                                  >
                                </div>
                                <div class="descricao flex">
                                  <span class="valorprod mr-2"
                                    >Valor protegido:
                                  </span>
                                  <span class="listItemsProtecoes">{{
                                    implemento.valorCobertura | currency
                                  }}</span>
                                </div>
                              </div>
                              <vs-divider class="mb-1 mt-1" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div class="pl-4 sm:w-2/5 w-full blocoValorPai">
          <div class="blocoValor p-4 mt-3 sm:mt-0">
            <div class="flex blocoValorCont">
              <h5 class="text-center mt-6">
                O valor total da sua cobertura é:
              </h5>
              <h4
                v-if="verificaDiferencaValoresMensalidade()"
                class="text-center valueCotacao mb-3 mt-3"
                style="color: #ccc; text-decoration: line-through"
              >
                {{ valorMensalidadeDiferenca | currency }}
              </h4>

              <h1 v-if="!isRecalculating" class="text-center valueCotacao">
                {{ valorMensalidade | currency }}
              </h1>
              <h1 v-else class="text-center valueCotacao">...</h1>

              <h5 class="pb-3 text-center">Mensalidade</h5>

              <vs-divider />

              <div v-if="dadosProposta.idEmpresa != empresa.ERP_VIAVANTE">
                <h5 class="text-center">Primeira Parcela:</h5>
                <h4
                  v-if="verificaDiferencaValoresEntrada()"
                  class="text-center valueCotacao mb-3 mt-3"
                  style="color: #ccc; text-decoration: line-through"
                >
                  {{ valorEntradaDiferenca | currency }}
                </h4>

                <h1 v-if="!isRecalculating" class="pb-3 text-center">
                  {{ valorEntrada | currency }}
                </h1>
                <h1 v-else class="pb-3 titleListItems">...</h1>
              </div>

              <div
                @click.stop.prevent="openModalQueroContratar"
                v-if="
                  dadosProposta.propostas[0].idStatus ===
                    statusCotacao.EM_ABERTO &&
                  !isInterno &&
                  !dadosProposta.propostas[0].dataAceite
                "
                class="mb-4 whatsAppDiv flex p-2 w-full fade-in justify-center hideInPrintVersion"
              >
                <div class="wppConsultor">
                  <h4 class="text-white queroContratar">Quero Contratar</h4>
                </div>
              </div>

              <div
                v-if="
                  !isInterno &&
                  dadosProposta.propostas[0].dataAceite &&
                  dadosProposta.propostas.some(
                    (proposta) =>
                      proposta.idStatus === statusCotacao.EM_PROCESSO_VISTORIA,
                  )
                "
                class="mb-4 flex p-2 w-full fade-in justify-center linkVistoriaDiv hideInPrintVersion"
                @click="modalVistoria = true"
              >
                <div class="wppConsultor">
                  <h4 class="text-white queroContratar">Lista de Vistorias</h4>
                </div>
              </div>

              <div
                v-if="
                  !isInterno &&
                  dadosProposta.propostas[0].dataAceite &&
                  dadosProposta.propostas[0].idStatus ===
                    statusCotacao.EM_ABERTO
                "
                class="mb-4 flex p-2 w-full fade-in justify-center linkVistoriaDiv hideInPrintVersion"
                @click="verificaDocumentosVistoria"
              >
                <div class="wppConsultor">
                  <h4 class="text-white queroContratar">
                    Verificar Documentos
                  </h4>
                </div>
              </div>

              <vs-divider class="mb-5 mt-5" />

              <h4 class="subtituloDetalhes mb-4 hideInPrintVersion">
                Enviar proposta
              </h4>
              <div class="flex w-full justify-around mb-3 hideInPrintVersion">
                <vx-tooltip
                  active="false"
                  text="Fazer Download"
                  onclick="window.print()"
                >
                  <div class="flex p-1 justify-center">
                    <span class="icons-cotacao">
                      <vs-icon
                        icon-pack="feather"
                        icon="icon-download"
                        color="#93aabe"
                        size="medium"
                        click="#"
                      ></vs-icon>
                    </span>
                  </div>
                </vx-tooltip>
                <div class="flex p-1 justify-center">
                  <a
                    target="_blank"
                    :href="
                      returnLinkWhatsCliente(
                        dadosProposta.dadosVendedor.usuario,
                      )
                    "
                  >
                    <vx-tooltip text="Enviar por WhatsApp">
                      <span class="icons-cotacao">
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-message-circle"
                          color="#93aabe"
                          size="medium"
                          click="#"
                        ></vs-icon>
                      </span>
                    </vx-tooltip>
                  </a>
                </div>
                <div
                  @click="copiarText(this)"
                  value="click to copy"
                  class="flex p-1 justify-center"
                >
                  <vx-tooltip text="Copiar">
                    <span class="icons-cotacao">
                      <vs-icon
                        icon-pack="feather"
                        icon="icon-copy"
                        color="#93aabe"
                        size="medium"
                        click="#"
                      ></vs-icon>
                    </span>
                  </vx-tooltip>
                </div>
              </div>
            </div>
            <div
              v-if="
                (!propostaVencida || aprovarPropostasVencidas) &&
                dadosProposta.propostas[0].idStatus ===
                  statusCotacao.EM_ABERTO &&
                !isInterno
              "
              class="hideInPrintVersion"
              button
            >
              <vs-divider class="mb-5" />

              <vs-card v-if="cupomHabilitado">
                <vs-alert
                  v-if="dadosProposta.propostas[0].cupom"
                  color="success"
                  active="true"
                  class="mt-1 mb-3"
                  style="height: auto !important"
                >
                  O cupom {{ dadosProposta.propostas[0].cupom }} foi aplicado!
                </vs-alert>

                <h5 class="text-center mt-3 subtituloDetalhes mb-4">
                  Cupom de desconto
                </h5>

                <div>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="cupom"
                    id="input-cupom"
                    autocomplete="off"
                    placeholder="Digite aqui o cupom"
                    v-model="cupomDesconto"
                    @keyup="mascaraCupom($event)"
                    :danger="dangerCupomDesconto"
                    danger-text="Informe o cupom"
                  />
                </div>
                <div class="mt-3">
                  <vs-button
                    color="dark"
                    type="gradient"
                    class="w-full"
                    @click="aplicarDesconto()"
                  >
                    Aplicar desconto
                  </vs-button>
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container avisoLeilao mb-5 pt-8 pb-8">
      <p class="flex text-black justify-center">
        Para veículos de Leilão, consulte nosso representante para obter
        informações sobre o valor da indenização.
      </p>
    </div>
    <footer class="p-4 pagebreak-inside-avoid">
      <div class="container">
        <div class="">
          <div id="Consultor+WPP" class="footerDivStyle">
            <div id="Consultor" class="flex justify-between items-center">
              <vs-avatar
                size="80px"
                :text="nomeAvatar"
                text-size="100%"
                color="rgb(59, 59, 59)"
                style="font-size: 50px"
              />
              <div>
                <h5 class="text-white">Corretor</h5>
                <h1 class="text-white">
                  {{ dadosProposta.dadosVendedor.usuario }}
                </h1>
                <h5 class="text-white">
                  {{ dadosProposta.dadosVendedor.usuarioEmail }}
                </h5>
              </div>
            </div>
            <div class="boxWpp mt-3 sm:mt-0">
              <a target="_blank" :href="returnLinkWhatsVendedor()">
                <div class="whatsAppDiv flex pr-6 pl-3 justify-between fade-in">
                  <div>
                    <img
                      src="../../assets/images/pages/wpp-icon.png"
                      width="50"
                    />
                  </div>
                  <div class="wppConsultor pt-1 pb-1 flex">
                    <p class="wppTexto text-white">WhatsApp do Corretor</p>
                    <p class="wppNumero text-white">
                      {{ dadosProposta.dadosVendedor.telefone }}
                    </p>
                  </div>
                </div></a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="container rodape">
        <vs-divider color="#93aabe" />
        <div class="flex direction-row items-center gap-3">
          <h5 class="text-white cotacaoFooter">
            Proposta criada em
            {{ ajustaDataHoraUtc(dadosProposta.propostas[0].createdAt) }}.
          </h5>
          <p
            class="showDesk"
            v-if="
              (dadosProposta.propostas[0].idStatus ===
                statusCotacao.EM_ABERTO ||
                dadosProposta.propostas[0].idStatus ===
                  statusCotacao.EM_PROCESSO_VISTORIA) &&
              exibeValidadeNaProposta
            "
          >
            <span
              :class="`con-vs-chip ${
                !propostaVencida
                  ? 'bg-success'
                  : this.aprovarPropostasVencidas
                  ? 'bg-warning'
                  : 'bg-danger'
              } text-white flex items-center`"
              style="display: inline-block; float: none; padding-left: 10px"
              >válida até
              {{
                calculaValidadeProposta(dadosProposta.propostas[0].createdAt)
              }}</span
            >
          </p>
        </div>
        <p
          class="showMobile"
          v-if="
            dadosProposta.propostas[0].idStatus === statusCotacao.EM_ABERTO ||
            dadosProposta.propostas[0].idStatus ===
              statusCotacao.EM_PROCESSO_VISTORIA
          "
        >
          <span
            :class="`con-vs-chip ${
              !propostaVencida
                ? 'bg-success'
                : this.aprovarPropostasVencidas
                ? 'bg-warning'
                : 'bg-danger'
            } text-white flex items-center`"
            style="display: inline-block; float: none; padding-left: 10px"
            >válida até
            {{
              calculaValidadeProposta(dadosProposta.propostas[0].createdAt)
            }}</span
          >
        </p>
      </div>
    </footer>

    <vs-popup
      class="holamundo"
      title="Confirmação de Contratação"
      :active.sync="popupActive"
    >
      <div v-if="!confirmarDados">
        <p>
          Ao clicar em "Confirmar", você será direcionado para o nosso APP, onde
          poderá completar os seus dados e fazer a vistoria.
        </p>
        <h4 class="my-4">Fique atento aos seguintes pontos:</h4>
        <p class="my-4">Algumas instruções para tirar as fotos:</p>
        <ol style="list-style-type: inherit; margin-left: 15px">
          <li>
            Escolha um local bem iluminado, de preferência de dia, em local
            aberto
          </li>
          <li>Sempre tire fotos com a visão nítida da placa do veículo</li>
          <li>Vidros e portas devem estar fechados</li>
          <li>
            Se você não possui tanto domínio e/ou manuseio no celular, peça um
            amigo ou parente para te ajudar. Lembrando que só você pode assinar
            e sair na selfie.
          </li>
        </ol>
        <vs-button
          class="mt-5 w-full"
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-check"
          icon-before
          size="large"
          @click="clickEntendi()"
          >ENTENDI</vs-button
        >
      </div>
      <div v-if="confirmarDados">
        <div v-if="!showBoxFinanceiro">
          <vs-alert
            color="warning"
            title="Atenção!!"
            active="true"
            class="my-3 mb-10"
            style="height: auto !important"
            >Esse passo é muito importante, para continuar confirme seus dados!
          </vs-alert>
          <form role="form" @submit.stop.prevent>
            <div class="vx-col container-radio">
              <vs-radio
                v-for="item in tiposDePessoa"
                :key="item.idTipoPessoa"
                v-model="tipoDePessoa"
                vs-name="btnRadioTipoPessoa"
                :vs-value="item.tipoPessoa"
                class="w-full mb-3"
              >
                {{ item.tipoPessoa }}
              </vs-radio>
            </div>

            <div v-if="tipoDePessoa === tipoPessoa.FISICA">
              <vs-input
                class="w-full no-icon-border mb-10"
                name="CPF/CNPJ"
                id="CPF"
                autocomplete="off"
                aria-autocomplete="none"
                role="presentation"
                label-placeholder="CPF"
                v-model="formConfirmacao.cpfcnpj"
                v-validate="{ required: true, min: 14 }"
                :state="validateState('CPF')"
                :danger="validateClass('CPF')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'###.###.###-##'"
                icon-pack="feather"
                icon="icon-user-check"
                icon-no-border
                :disabled="!isCpfCanChange()"
              />
            </div>
            <div v-else>
              <vs-input
                class="w-full no-icon-border mb-10"
                name="CNPJ"
                id="CNPJ"
                autocomplete="off"
                aria-autocomplete="none"
                role="presentation"
                label-placeholder="CNPJ"
                v-model="formConfirmacao.cpfcnpj"
                v-validate="{ required: true, min: 18 }"
                :state="validateState('CNPJ')"
                :danger="validateClass('CNPJ')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'##.###.###/####-##'"
                icon-pack="feather"
                icon="icon-briefcase"
                icon-no-border
                :disabled="!isCpfCanChange()"
              />
            </div>

            <vs-input
              class="w-full no-icon-border mb-10"
              label-placeholder="Nome"
              v-model="formConfirmacao.nome"
              name="Nome"
              v-validate="{ required: true }"
              :state="validateState('Nome')"
              :danger="validateClass('Nome')"
            />

            <vs-input
              name="email"
              icon="icon icon-mail"
              icon-pack="feather"
              label-placeholder="E-mail"
              v-model="formConfirmacao.email"
              class="w-full no-icon-border mb-10"
              v-validate="{ email: true }"
              :state="validateState('email')"
              :danger="validateClass('email')"
            />

            <vs-input
              class="w-full no-icon-border mb-10"
              name="Celular"
              id="Celular"
              label-placeholder="Celular"
              v-model="formConfirmacao.celular"
              v-validate="{ required: true, min: 15 }"
              :state="validateState('Celular')"
              :danger="validateClass('Celular')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'(##) #####-####'"
              icon-pack="feather"
              icon="icon-smartphone"
              icon-no-border
            />

            <div v-if="tipoDePessoa === tipoPessoa.FISICA">
              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="RG"
                v-model="formConfirmacao.rgIe"
                name="RG"
                key="RG"
                v-validate="{ required: true }"
                :state="validateState('RG')"
                :danger="validateClass('RG')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Data de Nascimento"
                v-mask="'##/##/####'"
                key="dataNascimento"
                v-model="formConfirmacao.dataNascimento"
                name="Data de Nascimento"
                v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                :state="validateState('Data de Nascimento')"
                :danger="validateClass('Data de Nascimento')"
              />
            </div>
            <div v-else>
              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Inscrição Estadual"
                v-model="formConfirmacao.rgIe"
                name="Inscrição Estadual"
                key="RGIE"
                v-validate="{ required: true }"
                :state="validateState('Inscrição Estadual')"
                :danger="validateClass('Inscrição Estadual')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Representante Legal"
                v-model="formConfirmacao.representanteLegal"
                name="Nome Completo Represente Legal"
                key="representanteLegal"
                v-validate="{ required: true }"
                :state="validateState('Nome Completo Represente Legal')"
                :danger="validateClass('Nome Completo Represente Legal')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Cpf do Representante"
                v-mask="'###.###.###-##'"
                key="cpfRepresentante"
                v-model="formConfirmacao.cpfRepresentante"
                name="Cpf do Representante"
                v-validate="{ required: true, min: 14 }"
                :state="validateState('Cpf do Representante')"
                :danger="validateClass('Cpf do Representante')"
              />
            </div>

            <hr class="my-6" />
            <h5 class="my-4">Endereço:</h5>

            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="CEP"
                  v-mask="'##.###-###'"
                  v-model="formConfirmacao.cep"
                  name="CEP"
                  @keyup.native="keymonitor"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('CEP')"
                  :danger="validateClass('CEP')"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Endereço"
                  v-model="formConfirmacao.endereco"
                  name="Endereço"
                  v-validate="{ required: true }"
                  :state="validateState('Endereço')"
                  :danger="validateClass('Endereço')"
                />
              </div>
              <div class="vx-col sm:w-1/6 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Número"
                  v-model="formConfirmacao.numero"
                  name="Número"
                  v-validate="{ required: true }"
                  :state="validateState('Número')"
                  :danger="validateClass('Número')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Complemento"
                  v-model="formConfirmacao.complemento"
                  name="Complemento"
                  :state="validateState('Complemento')"
                  :danger="validateClass('Complemento')"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2 mt-1">
                <vs-input
                  class="w-full"
                  label-placeholder="Bairro"
                  v-model="formConfirmacao.bairro"
                  name="Bairro"
                  v-validate="{ required: true }"
                  :state="validateState('Bairro')"
                  :danger="validateClass('Bairro')"
                />
              </div>

              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label class="label-select">Estado</label>
                <v-select
                  :options="listEstados"
                  v-model="formConfirmacao.estado"
                  name="Estado"
                  id="Estado"
                  v-validate="{ required: true }"
                  :class="{ 'error-select': validateClass('Estado') }"
                  @input="clearCidade"
                >
                </v-select>
              </div>

              <div class="vx-col sm:w-2/5 w-full mb-2">
                <label class="label-select">Cidade</label>
                <v-select
                  :options="listCidade"
                  v-model="formConfirmacao.cidade"
                  name="Cidade"
                  id="Cidade"
                  v-validate="{ required: true }"
                  :reduce="(item) => item.label"
                  :class="{ 'error-select': validateClass('Cidade') }"
                >
                </v-select>
              </div>
            </div>

            <!-- <hr class="my-6" />
            <div class="vx-row flex justify-center">
              <vs-button
                class="sm:w-4/5 w-full my-1"
                color="warning"
                icon-pack="feather"
                icon="icon-paperclip"
                @click.stop.prevent="buscaDocumentosVistoria"
              >
                Enviar Documentos
              </vs-button>
            </div>
            <div class="vx-row flex justify-center">
              <vs-button
                class="sm:w-4/5 w-full my-1"
                icon-pack="feather"
                icon="icon-edit-2"
              >
                Assinar
              </vs-button>
            </div> -->
          </form>

          <vs-button
            class="w-full mt-5"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            size="large"
            @click="contratar()"
            >CONFIRMAR</vs-button
          >
        </div>
        <div v-else>
          <h5 class="my-4">Financeiro</h5>

          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Forma de Pagamento - 1 Parcela</label
              >
              <v-select
                :options="listaProdutosAAvista[0].formas"
                name="Forma de Pagamento 1 Parcela"
                id="Forma de Pagamento 1 Parcela"
                v-model="formConfirmacao.idFormaPagamentoAVista"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                @input="verificaCartaoCredito('Adesão')"
                label="text"
                :class="{
                  'error-select': validateClass('Forma de Pagamento 1 Parcela'),
                }"
              >
              </v-select>
              <vs-card
                v-if="
                  formConfirmacao.idFormaPagamentoAVista.tipoPagamento ===
                  'Cartão de Crédito'
                "
                class="mt-4"
              >
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 mb-2">
                    <h4 class="pb-3 titleListItems mb-3 mt-2">
                      Entrada:
                      {{
                        somaValorTotalValoresAvistaAdesao(
                          dadosProposta.propostas,
                        ) | currency
                      }}
                    </h4>
                  </div>
                  <div class="vx-col sm:w-1/2 mb-2 text-right">
                    <vs-button
                      color="primary"
                      @click.stop.prevent="adicionarCartao('Adesão')"
                      >+
                      {{ listCartoes.length > 0 ? 'Outro' : 'Adicionar' }}
                      Cartão</vs-button
                    >
                  </div>
                </div>
                <ul v-if="listCartoes.length > 0" class="centerx">
                  <li
                    v-for="item in listCartoes"
                    :key="item.id"
                    @click.stop.prevent="selecionaCartao(item, 'Adesão')"
                    :class="`p-4 item-lista ${
                      item.selecionadoAdesao == true
                        ? 'border-success'
                        : 'border-dark'
                    }`"
                  >
                    <vs-chip color="dark mr-3">{{ item.bandeira }}</vs-chip>
                    {{ item.cardNumber }}
                    <vs-chip v-if="item.selecionadoAdesao" color="success ml-5"
                      >Selecionado</vs-chip
                    >
                  </li>
                </ul>
                <div v-else class="con-vs-alert con-vs-alert-warning p-3">
                  Nenhum Cartão Adicionado
                </div>
              </vs-card>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Forma de Pagamento - Mensalidade</label
              >
              <v-select
                :options="listaProdutosMensais[0].formas"
                name="Forma Pagamento Mensal"
                id="Forma Pagamento Mensal"
                v-model="formConfirmacao.idFormaPagamentoMensal"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                @input="verificaCartaoCredito('Mensalidade')"
                label="text"
                :class="{
                  'error-select': validateClass('Forma Pagamento Mensal'),
                }"
              >
              </v-select>
              <vs-card
                v-if="
                  formConfirmacao.idFormaPagamentoMensal.tipoPagamento ===
                  'Cartão de Crédito'
                "
                class="mt-4"
              >
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 mb-2">
                    <h4 class="pb-3 titleListItems mb-3 mt-2">
                      Mensalidade:
                      {{ valorMensalidade | currency }}
                    </h4>
                  </div>
                  <div class="vx-col sm:w-1/2 mb-2 text-right">
                    <vs-button
                      color="primary"
                      @click.stop.prevent="adicionarCartao('Mensalidade')"
                      >+
                      {{ listCartoes.length > 0 ? 'Outro' : 'Adicionar' }}
                      Cartão</vs-button
                    >
                  </div>
                </div>
                <ul v-if="listCartoes.length > 0" class="centerx">
                  <li
                    v-for="item in listCartoes"
                    :key="item.id"
                    @click.stop.prevent="selecionaCartao(item, 'Mensalidade')"
                    :class="`p-4 item-lista ${
                      item.selecionado == true
                        ? 'border-success'
                        : 'border-dark'
                    }`"
                  >
                    <vs-chip color="dark mr-3">{{ item.bandeira }}</vs-chip>
                    {{ item.cardNumber }}

                    <vs-chip v-if="item.selecionado" color="success ml-5"
                      >Selecionado</vs-chip
                    >
                  </li>
                </ul>
                <div v-else class="con-vs-alert con-vs-alert-warning p-3">
                  Nenhum Cartão Adicionado
                </div>
              </vs-card>
            </div>
          </div>

          <div class="vx-row">
            <div v-if="!diasVencimentoTypeCalendar" class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Dia de Vencimento da Mensalidade</label
              >
              <v-select
                :options="diasVencimento"
                name="Dia de Vencimento"
                id="Dia de Vencimento"
                v-model="formConfirmacao.diaVencimentoMensalidade"
                v-validate="{ required: true }"
                :reduce="(item) => item"
                :class="{
                  'error-select': validateClass('Dia de Vencimento'),
                }"
              >
              </v-select>
            </div>
            <div v-if="diasVencimentoTypeCalendar" class="mt-5 w-full vx-col">
              <h5>Dia de Vencimento Mensal</h5>

              <div class="vx-col mb-2 mt-3">
                <DateRadio
                  :diasDisponiveis="diasVencimento"
                  :diaJaDefinido="
                    dadosProposta.propostas[0].diaVencimentoMensalidade
                  "
                  @diaSelecionado="diaSelecionado($event)"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap justify-between my-5">
            <vs-alert
              v-if="$validator.errors.all().length > 0"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li
                  class="mb-2"
                  v-for="error in $validator.errors.all()"
                  :key="error.id"
                >
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
          </div>
          <vs-button
            class="mt-5 w-full"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            size="large"
            @click="contratar()"
            >CONFIRMAR e IR PARA A VISTORIA</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Adicione um Cartão de Crédito"
      :active.sync="modalCartaoCredito"
    >
      <div ref="elementFormaPagamento">
        <div>
          <cartaoCredito
            @adicionar="cartaoAdicionado"
            :idProspect="dadosProposta.dadosCliente.idProspect"
            :idEmpresa="dadosProposta.idEmpresa"
            :idProposta="dadosProposta.propostas[0].idProposta"
            :typeCard="tipoCartaoAdiciona"
            textoBotao="Adicionar Cartão"
            :key="keyCartao"
          ></cartaoCredito>
        </div>
      </div>
    </vs-popup>

    <div
      class="pagebreak-inside-avoid"
      v-if="dadosProposta.dadosAssociacao.contraCapaProposta"
    >
      <img
        class="capaImpressao showInPrintVersion pagebreak-inside-avoid"
        :src="dadosProposta.dadosAssociacao.contraCapaProposta"
      />
    </div>
    <ModalListVistorias
      :openModal="modalVistoria"
      :dados="dadosProposta.propostas"
      @close="modalVistoria = false"
    />
    <FormUploadDocumentoInvoice
      :dadosProposta="dadosProposta"
      :openModal="openModalDocumentos"
      :idProposta="idsPropostas"
      @assinar="passoAssinatura"
      @closeModalDocumentos="closeModalUploadManual"
    >
    </FormUploadDocumentoInvoice>
    <FormUploadAssinatura
      :idFrota="dadosProposta.idFrota"
      :openModal="openModalAssinatura"
      @uploadAssinatura="passoVistoriaPorPlaca"
      @closeModalAssinatura="openModalAssinatura = false"
    >
    </FormUploadAssinatura>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import service from '../../services';
import functions from '../../utils/functions';
import locale from './../../locale';
import VxTooltip from '../../layouts/components/vx-tooltip/VxTooltip.vue';
import cpfCnpj from '../../services/cpfCnpj';
import notify from './../../utils/notify';
import cartaoCredito from './../forms/FormCartaoCredito.vue';
import { setTimeout } from 'timers';
import vSelect from 'vue-select';
import {
  getSelectsCidades,
  getSelectsEstados,
} from './../../services/ufMunicipio';
import { obterParticipacaoProdutoInvoice } from '../../services/cotacao';
import DateRadio from '../../components/date-radio/DateRadio.vue';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import { BP } from '../../commons/constant/empresasBp';
import { STATUS_COTACAO } from '../../commons/status-cotacao';
import { TIPO_PESSOA } from '../../commons/constant/tipo-pessoa';
import ModalListVistorias from '../modais/ModalListVistorias';
import FormUploadDocumentoInvoice from '../forms/FormUploadDocumentoInvoice.vue';
import FormUploadAssinatura from '../forms/FormUploadAssinatura.vue';
import { decryptData } from '../../services/decryptData';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  name: 'multiPropostaBP',
  watch: {
    modalCartaoCredito: function (newValue) {
      if (newValue == false) {
        this.popupActive = true;
      }
    },
  },
  data() {
    return {
      functions: functions,
      existeProdutoOpcionalVeiculoSelecionado: null,
      linkRedirect: null,
      idRegistroFinanceiro: null,
      contadorBuscaRegistro: null,
      retornoAPI: null,
      retornoRegistroFinanceiro: null,
      formaPagamentoSelecionada: 'Cartão de Crédito',
      formasPagamentosGerais: [],
      showBoxFinanceiro: false,
      exibeFinanceiro: false,
      implementos: [],
      agregados: [],
      opcionais: [],
      produtosOpcionais: [],
      produtosObrigatorios: [],
      switchIncluiProtecao: [],
      produtosvalorMensal: [],
      dadosProposta: [],
      produtosRecuperado: [],
      confirmarDados: false,
      arrayDuplicados: [],
      aprovarPropostasVencidas: null,
      dangerCupomDesconto: false,
      cupomDesconto: null,
      propostaVencida: false,
      popupActive: false,
      nomeAvatar: '',
      cpfDuplicado: false,
      temDesconto: false,
      temDescontoEntrada: false,
      CPFdeOutroAssociado: false,
      tipoDePessoa: null,
      listCartoes: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      dadosFinanceiros: null,
      hasCartaoCredito: null,
      isCartaoAvista: null,
      isCartaoMensal: null,
      exibeFormCartao: false,
      formasPagamentoEncontradas: false,
      formConfirmacao: {
        cpfcnpj: null,
        celular: null,
        email: null,
        nome: null,
        rgIe: null,
        dataNascimento: null,
        representanteLegal: null,
        cpfRepresentante: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        canaisComunicacao: ['WhatsApp', 'Email', 'SMS'],
        diaVencimentoMensalidade: null,
        idFormaPagamentoAVista: {},
        idFormaPagamentoMensal: {},
      },
      tiposDePessoa: [
        { idTipoPessoa: 1, tipoPessoa: 'Pessoa Física' },
        { idTipoPessoa: 2, tipoPessoa: 'Pessoa Jurídica' },
      ],
      opcaoFgtsEscolhida: null,
      exibeValidadeNaProposta: null,
      listEstados: [],
      listCidade: [],
      isRecalculating: false,
      cartaoSelecionadoAdesao: null,
      cartaoSelecionadoMensalidade: null,
      modalCartaoCredito: false,
      tipoCartaoAdiciona: null,
      keyCartao: 0,
      statusCotacao: STATUS_COTACAO,
      empresa: BP,
      tipoProduto: TIPO_PRODUTO,
      tipoPessoa: TIPO_PESSOA,
      modalVistoria: false,
      totalMensal: null,
      totalMensalOriginal: null,
      totalAvistaOriginal: null,
      totalAvista: null,
      totalAvistaAdesao: null,
      totalMensalAgregado: null,
      totalMensalOriginalAgregado: null,
      totalAvistaOriginalAgregado: null,
      totalAvistaAgregado: null,
      chaveMulti: null,
      cupomHabilitado: false,
      idsPropostas: [],
      openModalDocumentos: false,
      openModalAssinatura: false,
      linkAssinatura: null,
    };
  },
  computed: {
    valorMensalidadeDiferenca: function () {
      const _valorMensalidadeDiferenca =
        this.totalMensalOriginal + this.totalMensalOriginalAgregado;

      return _valorMensalidadeDiferenca;
    },
    valorMensalidade: function () {
      const _valorMensalidade = this.totalMensal + this.totalMensalAgregado;
      return _valorMensalidade;
    },
    valorEntradaDiferenca: function () {
      const _valorEntradaDiferenca =
        this.totalAvistaOriginal + this.totalAvistaOriginalAgregado;

      return _valorEntradaDiferenca;
    },
    valorEntrada: function () {
      const _valorEntrada = this.totalAvista + this.totalAvistaAgregado;
      return _valorEntrada;
    },
  },
  methods: {
    async uploadAssinatura() {
      this.openModalAssinatura = false;
      this.freeBackModal();

      if (this.linkAssinatura) {
        try {
          await service.post('vistoria', 'post-assinatura-multi-vistoria', {
            idFrota: this.dadosProposta.idFrota,
            idProposta: this.dadosProposta.idProposta,
            urlFile: this.linkAssinatura,
          });
        } catch {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Não foi possível assinar a proposta.`,
            color: 'danger',
          });
        }
      }
    },
    async updateStatus() {
      try {
        await service.post('vistoria', 'update-status-multi-vistoria', {
          idFrota: this.dadosProposta.idFrota,
        });
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Não foi possível atualizar o status da proposta.`,
          color: 'danger',
        });
      }
    },
    somaValoresAgregado() {
      this.totalMensalOriginalAgregado = this.somaTotaisAgregados(
        true,
        'original',
      );
      this.totalMensalAgregado = this.somaTotaisAgregados(true);
      this.totalAvistaOriginalAgregado = this.somaTotaisAgregados(
        false,
        'original',
      );
      this.totalAvistaAgregado = this.somaTotaisAgregados(false);
    },
    somaValores(propostas) {
      this.somaValorTotalMes(propostas);
      this.somaValorTotalOriginal(propostas);
      this.somaValorTotalValoresAvista(propostas);
      this.somaValorTotalValoresAvistaOriginal(propostas);
    },
    verificaDiferencaValoresMensalidade() {
      return this.valorMensalidade != this.valorMensalidadeDiferenca;
    },
    verificaDiferencaValoresEntrada() {
      return this.valorEntrada != this.valorEntradaDiferenca;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    filtraProdutosVisiveis(produtos) {
      produtos.filter((produto) => produto.produtoVisivel);
    },

    calculaValidadeProposta(data) {
      const dataCriacaoProposta = data;
      let qtdDiasValidadeProposta;

      const propostaEmAberto =
        this.dadosProposta.propostas[0].idStatus ===
        this.statusCotacao.EM_ABERTO;

      if (propostaEmAberto) {
        qtdDiasValidadeProposta =
          this.dadosProposta.dadosAssociacao.qtdDiasVencimentoPropostaEmAberto +
          1;
      }

      const propostaEmVistoria =
        this.dadosProposta.propostas[0].idStatus ===
        this.statusCotacao.EM_PROCESSO_VISTORIA;

      if (propostaEmVistoria) {
        qtdDiasValidadeProposta =
          this.dadosProposta.dadosAssociacao
            .qtdDiasVencimentoPropostaEmVistoria + 1;
      }

      if (qtdDiasValidadeProposta) {
        const dataValidade = dayjs(dataCriacaoProposta).add(
          qtdDiasValidadeProposta,
          'days',
        );

        if (dayjs(dataValidade).diff(dayjs(), 'days') < 0) {
          this.propostaVencida = true;
        }

        if (this.propostaVencida && this.aprovarPropostasVencidas) {
          return dayjs().add(7, 'days').format('DD/MM/YYYY');
        }

        const _validadeProposta = `${dayjs(dataValidade).format(
          'DD/MM/YYYY',
        )} | ${dayjs(dataValidade).diff(dayjs(), 'days')} dias`.replace(
          '-',
          '',
        );

        return _validadeProposta;
      }

      const ultimoDiaMes = dayjs(data).endOf('month');

      if (dayjs(ultimoDiaMes).diff(dayjs(), 'days') < 0) {
        this.propostaVencida = true;
      }

      if (this.propostaVencida && this.aprovarPropostasVencidas) {
        return dayjs().add(7, 'days').format('DD/MM/YYYY');
      }

      const ultimoDiaValidade = `${dayjs(ultimoDiaMes).format(
        'DD/MM/YYYY',
      )} | ${dayjs(ultimoDiaMes).diff(dayjs(), 'days')} dias`.replace('-', '');

      return ultimoDiaValidade;
    },

    async contratar() {
      const objSend = { ...this.formConfirmacao };

      objSend.idCotacao = this.idsPropostas;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;

      if (objSend.estado) {
        objSend.estado = objSend.estado.label;
      }

      if (this.showBoxFinanceiro) {
        if (
          this.formConfirmacao.idFormaPagamentoAVista &&
          this.formConfirmacao.idFormaPagamentoAVista.tipoPagamento ===
            'Cartão de Crédito'
        ) {
          if (!this.cartaoSelecionadoAdesao) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Selecione ou Adicione um Cartão para pagamento da Primeira Parcela`,
              color: 'danger',
            });

            return;
          }
        }

        if (
          this.formConfirmacao.idFormaPagamentoMensal &&
          this.formConfirmacao.idFormaPagamentoMensal.tipoPagamento ===
            'Cartão de Crédito'
        ) {
          if (!this.cartaoSelecionadoMensalidade) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Selecione ou Adicione um Cartão para pagamento da Mensalidade`,
              color: 'danger',
            });

            return;
          }
        }
      }

      const cpfCnpjValido = cpfCnpj.valida_cpf_cnpj(
        this.formConfirmacao.cpfcnpj,
      );
      if (!cpfCnpjValido) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Este CPF/CNPJ não é válido`,
          color: 'danger',
        });

        return;
      }

      if (!this.showBoxFinanceiro) {
        this.showBoxFinanceiro = true;
        return;
      }
      const formValid = await this.$validator.validateAll();
      if (formValid) {
        try {
          this.$vs.loading();
          await service.post('CotacaoAberta', 'aceiteProposta', objSend);
        } catch {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível confirmar a Contratação',
            color: 'danger',
          });
        } finally {
          this.showBoxFinanceiro = false;
          this.confirmarDados = false;
          this.popupActive = false;
          this.freeBackModal();
          this.$vs.loading.close();
          this.buscaDados();
        }
      }
    },

    somaValorTotalMes(propostas) {
      const total = propostas.reduce((accumulator, proposta) => {
        const totalObrigatorio = this.hasValue(proposta.produtosObrigatorios)
          ? proposta.produtosObrigatorios.reduce((accumulator, element) => {
              const valor =
                element.isMensal && !element.excluido
                  ? accumulator + element.valorFinal
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        const totalOpcional = this.hasValue(proposta.produtosOpcionais)
          ? proposta.produtosOpcionais.reduce((accumulator, element) => {
              const valor =
                element.isMensal && element.selecionado
                  ? accumulator + element.valorFinal
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        return accumulator + totalObrigatorio + totalOpcional;
      }, 0);
      this.totalMensal = total;
      return total;
    },

    somaValorTotalOriginal(propostas) {
      const total = propostas.reduce((accumulator, proposta) => {
        const totalObrigatorio = this.hasValue(proposta.produtosObrigatorios)
          ? proposta.produtosObrigatorios.reduce((accumulator, element) => {
              const valor =
                element.isMensal && !element.excluido
                  ? accumulator + element.valor
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        const totalOpcional = this.hasValue(proposta.produtosOpcionais)
          ? proposta.produtosOpcionais.reduce((accumulator, element) => {
              const valor =
                element.isMensal && element.selecionado
                  ? accumulator + element.valor
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        return accumulator + totalObrigatorio + totalOpcional;
      }, 0);
      this.totalMensalOriginal = total;
      return total;
    },

    somaValorTotalValoresAvistaOriginal(propostas) {
      const total = propostas.reduce((accumulator, proposta) => {
        const totalObrigatorio = this.hasValue(proposta.produtosObrigatorios)
          ? proposta.produtosObrigatorios.reduce((accumulator, element) => {
              const valor = !element.isMensal
                ? accumulator + element.valor
                : accumulator;
              return valor;
            }, 0)
          : 0;

        const totalOpcional = this.hasValue(proposta.produtosOpcionais)
          ? proposta.produtosOpcionais.reduce((accumulator, element) => {
              const valor =
                !element.isMensal && element.selecionado
                  ? accumulator + element.valor
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        return accumulator + totalObrigatorio + totalOpcional;
      }, 0);
      this.totalAvistaOriginal = total;
      return total;
    },

    somaValorTotalValoresAvista(propostas) {
      const total = propostas.reduce((accumulator, proposta) => {
        const totalObrigatorio = this.hasValue(proposta.produtosObrigatorios)
          ? proposta.produtosObrigatorios.reduce((accumulator, element) => {
              const valor = !element.isMensal
                ? accumulator + element.valorFinal
                : accumulator;
              return valor;
            }, 0)
          : 0;

        const totalOpcional = this.hasValue(proposta.produtosOpcionais)
          ? proposta.produtosOpcionais.reduce((accumulator, element) => {
              const valor =
                !element.isMensal && element.selecionado
                  ? accumulator + element.valorFinal
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        return accumulator + totalObrigatorio + totalOpcional;
      }, 0);
      this.totalAvista = total;
      return total;
    },

    somaValorTotalValoresAvistaAdesao(propostas) {
      const total = propostas.reduce((accumulator, proposta) => {
        const totalObrigatorio = this.hasValue(proposta.produtosObrigatorios)
          ? proposta.produtosObrigatorios.reduce((accumulator, element) => {
              const valor =
                !element.isMensal &&
                element.idTipoProduto === this.tipoProduto.TIPO_PRODUTO_ADESAO
                  ? accumulator + element.valorFinal
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        const totalOpcional = this.hasValue(proposta.produtosOpcionais)
          ? proposta.produtosOpcionais.reduce((accumulator, element) => {
              const valor =
                !element.isMensal &&
                element.selecionado &&
                this.tipoProduto.TIPO_PRODUTO_ADESAO
                  ? accumulator + element.valorFinal
                  : accumulator;
              return valor;
            }, 0)
          : 0;

        return accumulator + totalObrigatorio + totalOpcional;
      }, 0);
      this.totalAvistaAdesao = total;
      return total;
    },

    hasValue(array) {
      const value = array && array.length > 0;
      return value;
    },

    somaTotaisAgregados(mensal = true, tipoValor = 'final') {
      const total = this.dadosProposta.propostas.reduce(
        (totalPropostas, proposta) => {
          const temAgregado = proposta.agregado;
          if (!temAgregado) return 0;

          const total = this.agregados.reduce((valorTotal, agregado) => {
            const {
              produtosObrigatorios,
              produtosOpcionais,
              valorComissaoAplicadaFinal,
            } = agregado;

            const valorCommissao = valorComissaoAplicadaFinal
              ? valorComissaoAplicadaFinal
              : 0;

            valorTotal += valorCommissao;

            return totalPropostas + valorTotal;
          }, 0);

          return total;
        },
        0,
      );
      return total;
    },

    marcaProdutosCarregamento(
      produtosOpcionais,
      produtosObrigatorios,
      proposta,
    ) {
      produtosOpcionais.forEach((opcional) => {
        if (opcional.selecionado) {
          if (!opcional.sobreporOutrosProdutos) {
            return;
          }
          const prodssobreporOutrosProdutos =
            opcional.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((sobrepoe) => {
            produtosObrigatorios.forEach((obrigatorio, indexObrigatorio) => {
              if (obrigatorio.idProduto === sobrepoe) {
                if (opcional.selecionado) {
                  proposta.produtosRemovidos.push(obrigatorio);
                  obrigatorio.excluido = true;
                  return;
                }
                proposta.produtosRemovidos.splice(indexObrigatorio, 1);
                obrigatorio.excluido = false;
              }
            });
          });
        }
      });
    },

    async selecionaProduto(item, selecionado, id, proposta) {
      const { produtosObrigatorios, produtosOpcionais } = proposta;

      try {
        this.isRecalculating = true;
        const produtosAtualizar = [];

        if (item.sobreporOutrosProdutos) {
          const podeSobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');

          podeSobreporOutrosProdutos.forEach((produto) => {
            produtosOpcionais.forEach((produtoSelecionado) => {
              if (Number(produto) === produtoSelecionado.idProduto) {
                if (item.selecionado && produtoSelecionado.selecionado) {
                  produtoSelecionado.selecionado = false;

                  const prodSobreposto = {
                    idProposta: id,
                    acao: !produtoSelecionado.selecionado
                      ? 'remover'
                      : 'adicionar',
                    idProduto: produtoSelecionado.idProduto,
                    valorFinal: produtoSelecionado.valorFinal,
                  };

                  produtosAtualizar.push(prodSobreposto);
                }
              }
            });
          });
        }

        if (item.produtosLinkados) {
          const idsProdutosLinkados = item.produtosLinkados.split(',');
          idsProdutosLinkados.forEach((idLink) => {
            if (idLink) {
              produtosOpcionais.forEach((produto) => {
                if (Number(idLink) === produto.idProduto) {
                  produto.selecionado = selecionado;
                  const _produto = {
                    idProposta: id,
                    acao: produto.selecionado ? 'adicionar' : 'remover',
                    idProduto: produto.idProduto,
                    valorFinal: produto.valorFinal,
                  };
                  produtosAtualizar.push(_produto);
                }
              });
            }
          });
        }
        if (item.sobreporOutrosProdutos) {
          const prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((produto) => {
            produtosObrigatorios.forEach((produtoSelecionado, index) => {
              if (produtoSelecionado.idProduto === Number(produto)) {
                if (item.selecionado) {
                  proposta.produtosRemovidos.push(produtoSelecionado);
                  produtoSelecionado.excluido = true;
                  return;
                }
                proposta.produtosRemovidos.splice(index, 1);
                produtoSelecionado.excluido = false;
              }
            });
          });
        }

        if (item.produtosComplementares) {
          const idsProdutosComplementares =
            item.produtosComplementares.split(',');
          idsProdutosComplementares.forEach((idComplemento) => {
            if (idComplemento) {
              produtosOpcionais.forEach((produto) => {
                if (Number(idComplemento) === Number(produto.idProduto)) {
                  produto.exibir = true;
                }
              });
            }
          });
          this.defineExibicaoProdutoOpcional();
        }

        const produtoAtualizacao = {
          acao: selecionado ? 'adicionar' : 'remover',
          idProduto: item.idProduto,
          valorFinal: item.valorFinal,
        };
        produtosAtualizar.unshift(produtoAtualizacao);

        const objSend = {
          idProposta: id,
          idRegional: this.dadosProposta.idRegional,
          produtos: produtosAtualizar,
        };

        await this.atulizaProdutosOpcionais('alteraOpcional', objSend);

        if (item.id_tipoProduto === this.tipoProduto.TIPO_PRODUTO_CASCO) {
          const participacao = await obterParticipacaoProdutoInvoice(
            item,
            selecionado,
          );

          const { valorCotaParticipacao, valorParticipacaoMinimo } =
            participacao;

          await service.post('CotacaoAberta', 'atualizarParticipacao', {
            idEmpresa: this.dadosProposta.idEmpresa,
            idProposta: id,
            produto: item,
            valorCotaParticipacao,
            valorParticipacaoMinimo,
            idProspect: this.dadosProposta.dadosCliente.idProspect,
          });
        }
        this.somaValores(this.dadosProposta.propostas);
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível Atualizar opcionais do veículo',
        );
      } finally {
        this.isRecalculating = false;
      }
    },

    copiarText() {
      const linkRelativo = window.location.origin;
      const texto = `${linkRelativo}/multi-proposta/${this.chaveMulti}`;
      const inputTest = document.createElement('input');
      inputTest.value = texto;
      document.body.appendChild(inputTest);
      inputTest.select();
      document.execCommand('copy');
      document.body.removeChild(inputTest);
    },
    async aplicarDesconto() {
      try {
        this.dangerCupomDesconto = false;

        if (!this.cupomDesconto) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Informe o cupom!');
          return;
        }

        if (
          this.dadosProposta.propostas[0].cupom ===
          this.cupomDesconto.toUpperCase()
        ) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Este cupom já foi uitlizado!');
          return;
        }

        this.$vs.loading();
        const payload = {
          cupom: this.cupomDesconto.toUpperCase(),
          idProposta: this.dadosProposta.propostas[0].idProposta,
          idEmpresa: this.dadosProposta.idEmpresa,
          idRegional: this.dadosProposta.idRegional,
        };

        await service.post('Campanha', 'aplicarCupom', payload);
        this.cupomDesconto = '';
        this.buscaDados();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(' ', 'g'), '-');
      this.dangerCupomDesconto = false;
    },

    returnLinkWhatsCliente(nome, celular) {
      const linkRelativo = window.location.origin;
      const texto = `Olá ${nome}, tudo bem? A proposta da ${this.dadosProposta.dadosAssociacao.nome} para proteger seus veículos foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${linkRelativo}/multi-proposta/${this.chaveMulti}`;
      const textoEncode = encodeURI(texto);
      const link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
      return link;
    },
    returnLinkWhatsVendedor() {
      const linkRelativo = window.location.origin;
      const texto = `Olá ${this.dadosProposta.dadosVendedor.usuario}, tudo bem? Sua proposta para proteger seus veículos foi gerada, você consegue aceitá-la e fazer sua vistoria agora mesmo, acesse ${linkRelativo}/multi-proposta/${this.chaveMulti}`;
      const textoEncode = encodeURI(texto);
      const link = `https://api.whatsapp.com/send?phone=55${this.dadosProposta.dadosVendedor.telefone}&text=${textoEncode}`;
      return link;
    },

    async preencheForm() {
      this.formConfirmacao.nome = this.dadosProposta.dadosCliente.associado;
      this.formConfirmacao.email = this.dadosProposta.dadosCliente.email;
      this.formConfirmacao.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
      this.formConfirmacao.celular = this.dadosProposta.dadosCliente.celular;
      this.formConfirmacao.rgIe = this.dadosProposta.dadosCliente.rg_ie;
      this.formConfirmacao.dataNascimento =
        this.dadosProposta.dadosCliente.dataNascimento;
      this.formConfirmacao.representanteLegal =
        this.dadosProposta.dadosCliente.representanteLegal;
      this.formConfirmacao.cpfRepresentante =
        this.dadosProposta.dadosCliente.cpfRepresentante;

      this.formConfirmacao.diaVencimentoMensalidade =
        this.dadosProposta.diaVencimentoMensalidade;

      if (this.dadosProposta.dadosCliente.tipo === 'Pessoa Física')
        this.tipoDePessoa = this.tipoPessoa.FISICA;
      else this.tipoDePessoa = this.tipoPessoa.JURIDICA;

      if (
        this.dadosProposta.dadosCliente.tipo === null ||
        this.dadosProposta.dadosCliente.tipo === undefined
      )
        this.tipoDePessoa = this.tipoPessoa.FISICA;

      this.formConfirmacao.cep = this.dadosProposta.dadosCliente.cep;
      this.formConfirmacao.endereco = this.dadosProposta.dadosCliente.endereco;
      this.formConfirmacao.numero = this.dadosProposta.dadosCliente.numero;
      this.formConfirmacao.complemento =
        this.dadosProposta.dadosCliente.complemento;
      this.formConfirmacao.bairro = this.dadosProposta.dadosCliente.bairro;
      this.formConfirmacao.estado = this.dadosProposta.dadosCliente.estado;
      this.formConfirmacao.cidade = this.dadosProposta.dadosCliente.cidade;

      await this.getListCidade(null, this.dadosProposta.dadosCliente.estado);
    },

    buscaFormasPagamento() {
      this.$vs.loading();

      service
        .post('CotacaoAberta', 'buscaFormasPagamento', {
          idEmpresa: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
          naoExibeTodas: false,
        })
        .then(async (res) => {
          this.exibeFinanceiro = true;
          this.formasPagamentoEncontradas = true;

          this.listCartoes = res.data.cartoes;

          this.listCartoes.forEach((element) => {
            if (element.selecionado) {
              this.cartaoSelecionadoMensalidade = element.id_associado_cartao;
            }
            if (element.selecionadoAdesao) {
              this.cartaoSelecionadoAdesao = element.id_associado_cartao;
            }
          });

          var formas = res.data.formasPagamento;
          this.formasPagamentosGerais = formas;

          var aux = [];

          for (let index = 0; index < formas.length; index++) {
            const element = formas[index];
            var valor = null;

            if (this.dadosFinanceiros)
              if (element.isMensal) {
                var findValor = this.dadosFinanceiros.mensais.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                valor = findValor.valor;
              } else {
                let findValor = this.dadosFinanceiros.avista.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                valor = findValor.valor;
              }

            if (index == 0) {
              aux.push({
                idProduto: element.idProduto,
                idTipoProduto: element.idTipoProduto,
                nomeProduto: element.nomeProduto,
                isMensal: element.isMensal,
                valor: valor,
                formas: [
                  {
                    value: {
                      idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                      tipoPagamento: element.nomePagamento,
                    },
                    text: element.nomePagamento,
                  },
                ],
              });
            } else {
              if (element.nomeProduto == formas[index - 1].nomeProduto) {
                var aux2 = aux.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                aux2.formas.push({
                  value: {
                    idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                    tipoPagamento: element.nomePagamento,
                  },
                  text: element.nomePagamento,
                });
              } else {
                aux.push({
                  idProduto: element.idProduto,
                  idTipoProduto: element.idTipoProduto,
                  nomeProduto: element.nomeProduto,
                  isMensal: element.isMensal,
                  valor: valor,
                  formas: [
                    {
                      value: {
                        idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                        tipoPagamento: element.nomePagamento,
                      },
                      text: element.nomePagamento,
                    },
                  ],
                });
              }
            }
          }

          this.listaProdutosMensais = [];
          this.listaProdutosAAvista = [];
          aux.forEach((element) => {
            element.formas.unshift({ value: null, text: 'Selecione' });
            if (element.isMensal) this.listaProdutosMensais.push(element);
            else this.listaProdutosAAvista.push(element);
          });

          await this.selecionaFormaPagamento();

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível encontrar as formas de Pagamento',
            color: 'danger',
          });
        });
    },
    async selecionaFormaPagamento() {
      let produtosAtualizaModel = [];
      produtosAtualizaModel = this.dadosProposta.propostas[0].produtos;
      await Promise.all(
        this.listaProdutosAAvista.map(async (produtoAVista) => {
          if (produtoAVista.nomeProduto == 'Entrada') {
            const produtoEncontrado = produtosAtualizaModel.find((produto) => {
              return (
                (produto.ismensal == false || produto.isMensal == false) &&
                produto.idTipoPagamentoEmpresa
              );
            });
            if (produtoEncontrado) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) produtoAVista.valor = formaEncontrada.value;
            }
          } else {
            const produtoEncontrado = produtosAtualizaModel.find((produto) => {
              return (
                (produto.idProduto || produto.id_produto) ==
                (produtoAVista.idProduto || produtoAVista.id_produto)
              );
            });
            if (produtoEncontrado && produtoEncontrado.idTipoPagamentoEmpresa) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) {
                produtoAVista.valor = formaEncontrada.value;
                if (produtoAVista.idTipoProduto == 1) {
                  this.formConfirmacao.idFormaPagamentoAVista =
                    formaEncontrada.value;
                }
              }
            }
          }
        }),
      );

      await Promise.all(
        this.listaProdutosMensais.map(async (produtoMensal) => {
          const produtoEncontrado = produtosAtualizaModel.find((produto) => {
            return (produto.isMensal || produto.ismensal) == true;
          });
          if (produtoEncontrado.idTipoPagamentoEmpresa) {
            let formaEncontrada = produtoMensal.formas.find((forma) => {
              return forma.text == produtoEncontrado.nomePagamento;
            });
            produtoMensal.valor = formaEncontrada.value;
            this.formConfirmacao.idFormaPagamentoMensal = formaEncontrada.value;
          }
        }),
      );

      if (this.listaProdutosMensais[0].formas.length == 2) {
        let res = this.listaProdutosMensais[0].formas.filter(
          (x) => x.text != 'Selecione',
        );
        this.formConfirmacao.idFormaPagamentoMensal = res[0].value;
      }

      if (this.listaProdutosAAvista[0].formas.length == 2) {
        let res = this.listaProdutosAAvista[0].formas.filter(
          (x) => x.text != 'Selecione',
        );
        this.formConfirmacao.idFormaPagamentoAVista = res[0].value;
      }
    },

    verificaCartaoCredito(tipo) {
      const hasCartao =
        this.formConfirmacao.idFormaPagamentoAVista.tipoPagamento ===
          'Cartão de Crédito' ||
        this.formConfirmacao.idFormaPagamentoMensal.tipoPagamento ===
          'Cartão de Crédito';

      if (this.listCartoes.length === 0 && hasCartao) {
        this.modalCartaoCredito = true;
        this.adicionarCartao(tipo);
      }
    },

    keymonitor: async function () {
      if (this.formConfirmacao.cep.length === 10) {
        this.$vs.loading();
        const cepbusca = this.formConfirmacao.cep
          .replace('.', '')
          .replace('-', '');
        try {
          const { data } = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });

          const _data = decryptData(data);
          this.formConfirmacao.endereco = _data.street;
          this.formConfirmacao.bairro = _data.neighborhood;
          this.formConfirmacao.cidade = _data.city;
          this.formConfirmacao.estado = _data.state;

          await this.getListCidade(null, _data.state);
        } catch {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não Foi possível encontrar o cep',
            color: 'danger',
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },

    async buscaDados() {
      this.isInterno = this.$route.query.interno;
      this.chaveMulti = this.$route.params.chave;
      try {
        this.$vs.loading({
          clickEffect: 'true',
          text: 'Aguarde, estamos gerando sua proposta',
        });
        const { data: multiProposta } = await service.post(
          'CotacaoAberta',
          'buscaDados',
          {
            chaveMulti: this.chaveMulti,
          },
        );

        this.dadosProposta = { ...multiProposta[0] };
        this.dadosProposta.propostas = [];
        document.title = `${
          this.dadosProposta.idEmpresa === this.empresa.ERP_GERAL
            ? 'Bem Protege'
            : this.dadosProposta.dadosAssociacao.nome
        }`;
        this.buscaConfigEmpresa();
        const nomeCompleto =
          this.dadosProposta.dadosVendedor.usuario.split(' ');
        const p1 = nomeCompleto[0].substring(0, 1);
        const p2 =
          nomeCompleto.length > 1
            ? nomeCompleto[nomeCompleto.length - 1].substring(0, 1)
            : '';
        this.nomeAvatar = p1 + p2;
        this.preencheForm();

        for (const proposta of multiProposta) {
          const produtosOpcionais = [];
          const produtosObrigatorios = [];

          if (
            proposta.jsonFacilitadorProdutos &&
            proposta.jsonFacilitadorProdutos != '0'
          ) {
            proposta.jsonFacilitadorProdutos = JSON.parse(
              proposta.jsonFacilitadorProdutos,
            );

            if (proposta.jsonFacilitadorProdutos) {
              proposta.jsonFacilitadorProdutos.forEach((produto) => {
                // produtos não obrigatorios
                if (!produto.obrigatorio) {
                  produto.selecionado = false;
                  const aux = proposta.produtos.find(
                    (prod) => prod.id_produto === produto.id_produto,
                  );

                  if (aux) {
                    produto.selecionado = true;
                  }

                  const novoProduto = {
                    idProduto: produto.id_produto,
                    selecionado: produto.selecionado,
                    nomeProduto: produto.nomeProduto,
                    valor: produto.valor,
                    valorFinal: produto.valorFinal,
                    isMensal: produto.ismensal,
                    produtosLinkados: produto.produtosLinkados,
                    sobreporOutrosProdutos: produto.sobreporOutrosProdutos,
                    produtoVisivel: produto.produtoVisivel,
                    visivelProposta: produto.visivelProposta,
                    produtosComplementares: produto.produtosComplementares,
                    isComplementar: produto.isComplementar,
                    exibir: true,
                    valorCotaParticipacao: produto.valorCotaParticipacao,
                    valorParticipacaoMinimo: produto.valorParticipacaoMinimo,
                    id_tipoProduto: produto.id_tipoProduto,
                  };
                  produtosOpcionais.push(novoProduto);
                }
              });
            }
          } else {
            const produtoOpcional = proposta.produtos
              .filter((produto) => !produto.obrigatorio)
              .map((produto) => ({
                idProduto: produto.id_produto,
                selecionado: true,
                nomeProduto: produto.nomeProduto,
                descontoConcedido: produto.descontoConcedido,
                valorFinal: produto.valorFinal,
                isMensal: produto.isMensal,
                produtoVisivel: produto.produtoVisivel,
                visivelProposta: produto.visivelProposta,
                produtosComplementares: produto.produtosComplementares,
                isComplementar: produto.isComplementar,
                exibir: true,
                valorCotaParticipacao: produto.valorCotaParticipacao,
                valorParticipacaoMinimo: produto.valorParticipacaoMinimo,
                idTipoProduto: produto.idTipoProduto,
              }));
            produtosOpcionais.push(...produtoOpcional);
          }

          // produtos obrigatórios
          const produtoObrigatorio = proposta.produtos
            .filter((produto) => produto.obrigatorio)
            .map((produto) => ({
              idProduto: produto.id_produto,
              selecionado: true,
              nomeProduto: produto.nomeProduto,
              descontoConcedido: produto.descontoConcedido,
              valor: produto.valor,
              valorFinal: produto.valorFinal,
              isMensal: produto.isMensal,
              produtoVisivel: produto.produtoVisivel,
              visivelProposta: produto.visivelProposta,
              produtosComplementares: produto.produtosComplementares,
              isComplementar: produto.isComplementar,
              idTipoProduto: produto.idTipoProduto,
              exibir: true,
            }));

          produtosObrigatorios.push(...produtoObrigatorio);

          if (this.hasValue(produtosOpcionais)) {
            produtosOpcionais.sort((a, b) =>
              a.nomeProduto < b.nomeProduto
                ? -1
                : Number(a.nomeProduto > b.nomeProduto),
            );
          }

          this.filtraProdutosVisiveis(produtosObrigatorios);
          this.filtraProdutosVisiveis(produtosOpcionais);
          this.marcaProdutosCarregamento(
            produtosOpcionais,
            produtoObrigatorio,
            proposta,
          );

          const temAgregado = proposta.agregado && proposta.agregados;
          if (temAgregado) {
            const _agregados = proposta.agregados.reduce((acc, item) => {
              const _jsonFacilitadorProdutos = JSON.parse(
                item.JsonFacilitadorProdutos,
              );

              const {
                produtosObrigatorios: _produtosObrigatorios,
                produtosNaoObrigatorios: _produtosNaoObrigatorios,
              } = this.formataProdutos(_jsonFacilitadorProdutos);

              const dadosProdutosSelecionados = item.produtosAgregado;
              const produtosOpcionais = [];

              const produtosObrigatorios = _produtosObrigatorios.reduce(
                (acc, prodOgrig) => {
                  const _prodObriSelecionado = dadosProdutosSelecionados.find(
                    (produto) => produto.idProduto == prodOgrig.id_produto,
                  );

                  if (_prodObriSelecionado) {
                    const _produto = {
                      idPropostaProdutoComplemento:
                        _prodObriSelecionado.idPropostaProdutoComplemento,
                      idPropostaComplemento:
                        _prodObriSelecionado.idPropostaComplemento,
                      idProposta: _prodObriSelecionado.idProposta,
                      idProduto:
                        _prodObriSelecionado.id_produto ||
                        _prodObriSelecionado.idProduto ||
                        _prodObriSelecionado.id,
                      valor: _prodObriSelecionado.valor,
                      descontoConcedido: _prodObriSelecionado.descontoConcedido,
                      valorFinal: _prodObriSelecionado.valorFinal,
                      valorDescontoCupom:
                        _prodObriSelecionado.valorDescontoCupom,
                      selecionado: true,
                      nomeProduto: _prodObriSelecionado.nomeProduto,
                      isMensal: _prodObriSelecionado.isMensal,
                      produtoVisivel: _prodObriSelecionado.produtoVisivel,
                      visivelProposta: _prodObriSelecionado.visivelProposta,
                      idTipoPagamentoEmpresa:
                        _prodObriSelecionado.idTipoPagamentoEmpresa,
                      idTipoDesconto: _prodObriSelecionado.idTipoDesconto,
                    };

                    acc.push(_produto);

                    return acc;
                  } else {
                    return acc;
                  }
                },
                [],
              );

              const produtosNaoObrigatorios = _produtosNaoObrigatorios.reduce(
                (acc, prodNOgrig) => {
                  const _prodNaoObriSelecionado =
                    dadosProdutosSelecionados.find(
                      (produto) => produto.idProduto == prodNOgrig.id_produto,
                    );

                  if (_prodNaoObriSelecionado) {
                    const _produto = {
                      idPropostaProdutoComplemento:
                        _prodNaoObriSelecionado.idPropostaProdutoComplemento,
                      idPropostaComplemento:
                        _prodNaoObriSelecionado.idPropostaComplemento,
                      idProposta: _prodNaoObriSelecionado.idProposta,
                      idProduto:
                        _prodNaoObriSelecionado.id_produto ||
                        _prodNaoObriSelecionado.idProduto ||
                        _prodNaoObriSelecionado.id,
                      valor: _prodNaoObriSelecionado.valor,
                      descontoConcedido:
                        _prodNaoObriSelecionado.descontoConcedido,
                      valorFinal: _prodNaoObriSelecionado.valorFinal,
                      valorDescontoCupom:
                        _prodNaoObriSelecionado.valorDescontoCupom,
                      selecionado: true,
                      nomeProduto: _prodNaoObriSelecionado.nomeProduto,
                      isMensal: _prodNaoObriSelecionado.isMensal,
                      produtoVisivel: _prodNaoObriSelecionado.produtoVisivel,
                      visivelProposta: _prodNaoObriSelecionado.visivelProposta,
                      idTipoPagamentoEmpresa:
                        _prodNaoObriSelecionado.idTipoPagamentoEmpresa,
                      idTipoDesconto: _prodNaoObriSelecionado.idTipoDesconto,
                      produtosLinkados:
                        _prodNaoObriSelecionado.produtosLinkados,
                      sobreporOutrosProdutos:
                        _prodNaoObriSelecionado.sobreporOutrosProdutos,
                    };

                    produtosOpcionais.push(_produto);
                    acc.push(_produto);
                  } else {
                    produtosOpcionais.push(prodNOgrig);
                  }

                  return acc;
                },
                [],
              );

              const produtosSelecionados = JSON.parse(
                item.produtosSelecionados,
              );

              acc.push({
                ...item,
                produtosObrigatorios,
                produtosNaoObrigatorios,
                dadosProdutosSelecionados,
                produtosSelecionados,
                produtosOpcionais,
                produtosRemovidos: [],
              });

              return acc;
            }, []);

            this.agregados = _agregados;
          }

          const temImplemento = proposta.implemento && proposta.implementos;
          if (temImplemento) {
            this.implementos = proposta.implementos;
          }

          this.verificaExisteEscolhidoOpcional('veiculo', produtosOpcionais);

          if (this.agregados.length > 0) {
            this.verificaExisteEscolhidoOpcional('agregado', proposta);
          }
          this.dadosProposta.propostas.push({
            ...proposta,
            produtosOpcionais,
            produtosObrigatorios,
            agregados: this.agregados,
            implementos: this.implementos,
            produtosRemovidos: [],
          });
        }
        this.defineExibicaoProdutoOpcional();
        this.somaValores(this.dadosProposta.propostas);
        this.somaValoresAgregado();
        this.buscaFormasPagamento(this.dadosProposta.propostas[0]);
        this.idsPropostas = this.dadosProposta.propostas.map(
          (proposta) => proposta.idProposta,
        );
        this.verificarPropostaVisualizada();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
        this.isRecalculating = false;
      }
    },

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async buscaRetornoRegistroFinanceiro() {
      this.contadorBuscaRegistro = this.contadorBuscaRegistro + 1;

      await this.sleep(10000);

      if (!this.retornoRegistroFinanceiro) {
        this.$vs.loading();
        service
          .post('CotacaoAberta', 'buscaDadosProcessamentoRegistroFinanceiro', {
            idRegistroFinanceiro: this.idRegistroFinanceiro,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.data[0].dataProcessamento) {
              this.retornoRegistroFinanceiro = res.data[0];
              this.retornoAPI = JSON.parse(
                this.retornoRegistroFinanceiro.retornoAPI,
              );
            } else {
              this.buscaRetornoRegistroFinanceiro();
            }
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      }
    },

    formataProdutos(produtos) {
      const _produtos = produtos;

      const produtosObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === true,
      );

      const produtosNaoObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === false,
      );

      const dadosProdutosSelecionados = produtosObrigatorios;

      return {
        produtosObrigatorios,
        produtosNaoObrigatorios,
        dadosProdutosSelecionados,
      };
    },
    async selecionaProdutoAgregado(item, selecionado, idAgregado, proposta) {
      try {
        this.isRecalculating = true;
        const produtosAtualizar = [];

        if (item.sobreporOutrosProdutos) {
          //item é o objeto do produto
          const podeSobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');

          podeSobreporOutrosProdutos.forEach((idProduto) => {
            proposta.agregados[idAgregado].produtosOpcionais.forEach(
              (elementSel) => {
                if (Number(idProduto) === elementSel.id_produto) {
                  if (item.selecionado && elementSel.selecionado) {
                    elementSel.selecionado = false;
                  }
                }
              },
            );
          });
        }

        const idsProdutosLinkados = item.produtosLinkados.split(',');

        idsProdutosLinkados.forEach((idLink) => {
          if (idLink) {
            proposta.agregados[idAgregado].produtosOpcionais.forEach(
              (element) => {
                if (Number(idLink) === element.id_produto) {
                  element.selecionado = selecionado;
                  const _produto = {
                    idProposta: proposta.idProposta,
                    acao: element.selecionado ? 'adicionar' : 'remover',
                    idProduto: element.id_produto,
                    valorFinal: element.valorFinal,
                  };
                  produtosAtualizar.push(_produto);
                }
              },
            );
          }
        });

        if (item.sobreporOutrosProdutos) {
          const prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((idProduto) => {
            proposta.agregados[idAgregado].produtosObrigatorios.forEach(
              (elementSel, index) => {
                if (elementSel.id_produto === Number(idProduto)) {
                  if (item.selecionado) {
                    proposta.agregados[idAgregado].produtosRemovidos.push(
                      elementSel,
                    );
                    elementSel.excluido = true;
                    return;
                  }
                  proposta.agregados[idAgregado].produtosRemovidos.splice(
                    index,
                    1,
                  );
                  elementSel.excluido = false;
                }
              },
            );
          });
        }

        const acao = selecionado ? 'adicionar' : 'remover';

        const objSend = {};
        objSend.idProposta = proposta.agregados[idAgregado].idProposta;
        objSend.idPropostaComplemento =
          proposta.agregados[idAgregado].idPropostaComplemento;
        objSend.acao = acao;
        objSend.idProduto = item.idProduto || item.id_produto || item.id;
        objSend.idPropostaProdutoComplemento =
          acao === 'remover' ? item.idPropostaProdutoComplemento : null;
        objSend.valorFinal = item.valorFinal;

        produtosAtualizar.unshift(objSend);
        produtosAtualizar.unshift(proposta.idProposta);
        produtosAtualizar.unshift(
          proposta.agregados[idAgregado].idPropostaComplemento,
        );
        produtosAtualizar.unshift(acao);
        produtosAtualizar.unshift(this.dadosProposta.idRegional);

        await this.atulizaProdutosOpcionais(
          'alteraOpcionalAgregado',
          produtosAtualizar,
        );
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível Atualizar opcionais do agregado',
        );
      } finally {
        this.isRecalculating = false;
        this.somaValoresAgregado();
      }
    },

    async atulizaProdutosOpcionais(acao, objSend) {
      try {
        this.$vs.loading();
        await service.post('CotacaoAberta', acao, objSend);
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Não foi possível Atualizar opcionais`,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    verificaExisteEscolhidoOpcional(tipo, produtosOpcionais) {
      if (tipo === 'veiculo') {
        if (this.hasValue(produtosOpcionais)) {
          const existeOpcional = produtosOpcionais.find(
            (produto) => produto.selecionado,
          );
          this.existeProdutoOpcionalVeiculoSelecionado = existeOpcional;
        }
        return;
      }

      if (tipo === 'agregado') {
        this.dadosProposta.propostas.forEach((proposta) => {
          const existeOpcionalAgregado = proposta.agregados.find((agregado) => {
            return agregado.produtosOpcionais.find((produto) => {
              return produto.selecionado;
            });
          });
          proposta.existeProdutoOpcionalAgregadoSelecionado =
            existeOpcionalAgregado;
          return;
        });
      }

      return false;
    },
    ajustaDataHoraUtc(data) {
      const dataAjustada = dayjs.utc(data).local().format('DD/MM/YYYY HH:mm');
      return dataAjustada;
    },
    optionsDiasVencimento(arrayDiasVencimento) {
      const dataVistoria = new Date();
      const diaDoMesVistoria = dataVistoria.getDate();
      const arrStr = arrayDiasVencimento
        .split(',')
        .map(Number)
        .sort((a, b) => a - b);
      if (diaDoMesVistoria >= 1 && diaDoMesVistoria <= 31) {
        const maxDay = Math.min(diaDoMesVistoria, 31);
        const novoArrayVencimento = arrStr.filter(
          (element) => element <= maxDay + 4 && maxDay - element <= 5,
        );
        if (diaDoMesVistoria >= 16) novoArrayVencimento.push(10);
        if (diaDoMesVistoria >= 21) novoArrayVencimento.push(15);
        if (diaDoMesVistoria >= 26) novoArrayVencimento.push(20);

        return novoArrayVencimento.sort((a, b) => a - b);
      }
    },
    async buscaConfigEmpresa() {
      try {
        this.$vs.loading();
        const dadosEmpresa = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/' + this.dadosProposta.idEmpresa,
        );

        const _dadosEmpresa = decryptData(dadosEmpresa.data);
        const {
          exibeValidadeNaProposta,
          diasVencimento,
          vencimentoMensalidadeTipo,
        } = _dadosEmpresa[0];
        this.$vs.loading.close();

        if (exibeValidadeNaProposta) this.exibeValidadeNaProposta = true;

        if (diasVencimento) {
          this.diasVencimento = functions.verificaEmpresaBemProtege(
            this.dadosProposta.idEmpresa,
          )
            ? this.optionsDiasVencimento(diasVencimento)
            : diasVencimento.split(',');

          this.diasVencimentoTypeCalendar =
            vencimentoMensalidadeTipo === 'calendar';
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },

    verificarPropostaVisualizada() {
      !this.dadosProposta.propostas[0].propostaVisualizada &&
        this.visualizarProposta();
      !this.dadosProposta.propostas[0].propostaVisualizada &&
        this.notificarConsultorPropostaVisualizada();
    },
    visualizarProposta() {
      return service.post('CotacaoAberta', 'atualiza-tabela-proposta', {
        idProposta: this.dadosProposta.propostas[0].idProposta,
        propostaVisualizada: true,
      });
    },
    notificarConsultorPropostaVisualizada() {
      return service.post(
        'CotacaoAberta',
        'notificar-consultor-proposta-visualizada',
        {
          idEmpresaAlternativo: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.propostas[0].idProposta,
          idUsuario: this.dadosProposta.idUsuario,
        },
      );
    },
    async getListCidade(id, sigla = null) {
      if (sigla) {
        id = this.listEstados.find((estado) => estado.label == sigla).id;
      }

      if (!id) {
        return;
      }

      try {
        this.listCidade = await getSelectsCidades(this.$vs, id);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async clearCidade(value) {
      this.formConfirmacao.cidade = null;

      if (value) {
        await this.getListCidade(value.id);
      }
    },

    defineExibicaoProdutoOpcional() {
      this.dadosProposta.propostas.forEach((proposta) => {
        proposta.produtosOpcionais.forEach((produto) => {
          if (produto.produtosComplementares && !produto.selecionado) {
            const produtosComplementares =
              produto.produtosComplementares.split(',');

            proposta.produtosOpcionais.forEach((prod) => {
              produtosComplementares.forEach((id) => {
                if (Number(id) === prod.idProduto && prod.exibir) {
                  prod.exibir = false;
                  prod.selecionado = false;

                  const index = proposta.produtos.findIndex((prod) => {
                    return prod.id_produto === Number(id);
                  });

                  if (index > 0) {
                    proposta.produtos.splice(index, 1);
                  }
                }
              });
            });
          }
        });
      });
    },

    isCpfCanChange() {
      let retorno = true;
      if (
        this.dadosProposta.dadosCliente.situacao ||
        this.dadosProposta.dadosCliente.idStatus
      ) {
        retorno = false;
      }

      return retorno;
    },
    cartaoAdicionado(res) {
      this.modalCartaoCredito = false;
      this.popupActive = true;
      this.blockBackModal();

      this.listCartoes.forEach((element) => {
        if (res.tipoCartao == 'Mensalidade') element.selecionado = false;
        else element.selecionadoAdesao = false;
      });
      res.id_associado_cartao = res.idCartao;
      this.listCartoes.push(res);
      if (res.tipoCartao == 'Mensalidade')
        this.cartaoSelecionadoMensalidade = res.idCartao;
      else this.cartaoSelecionadoAdesao = res.idCartao;
      this.keyCartao = this.keCartao + 1;
      //this.buscaFormasPagamento();
    },
    selecionaCartao(item, tipoCartao) {
      this.listCartoes.forEach((element) => {
        if (element.id_associado_cartao == item.id_associado_cartao) {
          if (tipoCartao == 'Mensalidade') element.selecionado = true;
          else element.selecionadoAdesao = true;
        } else {
          if (tipoCartao == 'Mensalidade') element.selecionado = false;
          else element.selecionadoAdesao = false;
        }
      });

      if (tipoCartao == 'Mensalidade')
        this.cartaoSelecionadoMensalidade = item.id_associado_cartao;
      else this.cartaoSelecionadoAdesao = item.id_associado_cartao;

      this.$vs.loading();
      service
        .post('CotacaoAberta', 'AtualizarCartaoAssociadoPrincipal', {
          idProspect: this.dadosProposta.dadosCliente.idProspect,
          idAssociadoCartao: item.id_associado_cartao,
          tipoCartao: tipoCartao,
        })
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    adicionarCartao(tipoCartao) {
      this.tipoCartaoAdiciona = tipoCartao;
      this.modalCartaoCredito = true;
      this.popupActive = false;
      this.freeBackModal();
    },
    clickEntendi() {
      this.confirmarDados = true;
    },

    /**
     * Handles the selection of a day for monthly billing.
     *
     * @param {number} dia - The selected day for monthly billing.
     * @returns {void}
     * @emits reatribuiDiaVencimento - Emitted after updating the selected day with the selected day as payload.
     */
    diaSelecionado(dia) {
      this.formConfirmacao.diaVencimentoMensalidade = dia;
    },
    async verificaDocumentosVistoria() {
      this.blockBackModal();
      this.openModalDocumentos = true;
    },
    closeModalUploadManual() {
      this.freeBackModal();
      this.openModalDocumentos = false;
    },
    passoAssinatura() {
      this.openModalDocumentos = false;
      this.openModalAssinatura = true;
    },
    async passoProcessoVistoria() {
      this.linkAssinatura;
    },
    async passoVistoriaPorPlaca(linkAssinatura) {
      this.$vs.loading();
      this.linkAssinatura = linkAssinatura;
      await this.uploadAssinatura();
      await this.updateStatus();
      this.$vs.loading.close();
      this.buscaDados();
    },
    openModalQueroContratar() {
      this.popupActive = true;
      this.blockBackModal();
    },
    blockBackModal() {
      document.body.classList.remove('overflow-auto');
      document.body.classList.add('overflow-hidden');
    },
    freeBackModal() {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.add('overflow-auto');
    },
  },
  async created() {
    this.listEstados = await getSelectsEstados();
    await this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  mounted() {},
  components: {
    VxTooltip,
    cartaoCredito,
    vSelect,
    DateRadio,
    ModalListVistorias,
    FormUploadDocumentoInvoice,
    FormUploadAssinatura,
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

* {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

.header-aprove {
  background-color: #2ecc71;
  font-weight: 600 !important;
  font-size: 20px;
}

.whatsAppDiv {
  background-color: #2ecc71;
  border-radius: 40px;
  align-items: center;
}

.status3e4 {
  background-color: #ee8370;
  border-radius: 40px;
  align-items: center;
}

.whatsAppDiv:hover {
  cursor: pointer;
  animation: fadeBackgroundIn 0.5s;
  animation-fill-mode: forwards;
}
.linkVistoriaDiv {
  background-color: #2e98fc;
  border-radius: 40px;
  align-items: center;
}
.linkVistoriaDiv:hover {
  cursor: pointer;
  animation: fadeLinkVistoriaBg 0.3s;
  animation-fill-mode: forwards;
}

@keyframes fadeBackgroundIn {
  from {
    background-color: #2ecc71;
  }
  to {
    background-color: #26b564;
  }
}
@keyframes fadeLinkVistoriaBg {
  from {
    background-color: #2e98fc;
  }
  to {
    background-color: #2a7ddd;
  }
}

.wrapper {
  position: relative;
  top: 0;
  width: 100%;
}

.wppConsultor {
  flex-direction: column;
  align-items: center;
}

.wppTexto {
  font-size: 0.8rem;
  font-weight: 700 !important;
}
.wppNumero {
  font-size: 1.4rem;
  font-weight: 700 !important;
}

.bgPrimay {
  background-color: rgb(16, 72, 129);
}
.blueBar {
  background-color: rgb(16, 72, 129);
  color: white;
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.bar-without-video {
  height: 15rem;
}

.contInfo {
  justify-content: space-between;
  margin-top: -20px;
}

.textBlueBar1 {
  font-size: 1.6rem;
}

.blocoInfo {
  background-color: white;
  border: 1px #d8e2ef solid;
  border-radius: 6px;
}

.titleListItems {
  font-size: 20px;
  font-weight: 600;
  color: #626262;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.listItemsOpcionais {
  font-weight: 600;
  color: rgb(59, 59, 59);
  font-size: 0.8rem;
}

.wppCotacao {
  background-color: #93aabe;
}

.blocoValor {
  background-color: white;
  border: 1px #d8e2ef solid;
  border-radius: 6px;
  position: sticky;
  top: 10px;
}

.blocoValorCont {
  flex-direction: column;
  align-items: center;
}

.valueCotacao {
  font-weight: 800;
}

.icons-cotacao {
  cursor: pointer;
}

.queroContratar {
  font-weight: 600;
}

.avisoMensalidade {
  font-size: 0.8rem;
  font-weight: 500;
}

.subtituloDetalhes {
  font-weight: 550;
}

.avisoLeilao {
  background-color: #d3dfea;
}

.listItems {
  font-size: 1rem;
  color: black;
  font-weight: 600;
}

footer {
  background-color: #373f47;
}

.cotacaoFooter {
  font-size: 0.9rem;
}

.showMobile {
  display: none;
}

.rodape .showMobile span,
.rodape .showDesk span {
  padding-top: 1px;
}

.showInPrintVersion {
  display: none;
}

.footerDivStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

@media (max-width: 576px) {
  .produtosBeneficios .flex {
    flex: 1;
    margin-right: 10px;
  }

  .produtosBeneficios .descricao .listItemsProtecoes {
    color: #666 !important;
    font-weight: normal;
  }

  .showMobile {
    display: block;
  }

  .showDesk {
    display: none;
  }

  .footerDivStyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column !important;
  }
}
.item-collapse .vs-collapse-item--icon-header i {
  font-size: 30px;
}
.item-collapse .vs-collapse-item--icon-header {
  background-color: #2a7ddd;
  height: 50px;
  width: 50px;
  color: white;
  padding: 7px;
  border-radius: 50%;
}

.collapse-invoice .open-item .vs-collapse-item--content {
  max-height: fit-content !important;
}
</style>

<style type="text/css" media="print">
@media print {
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
@page {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

.error-select .vs__dropdown-toggle {
  border-color: rgba(var(--vs-danger), 1) !important;
}
</style>

<style scoped>
.border-success {
  border: 1px solid #2ecc71;
}

.border-dark {
  border: 1px solid #ebebeb !important;
}

.item-lista {
  cursor: pointer;
}

.fixed-bottom {
  position: fixed;
  bottom: 0px;
  width: 100%;
  text-align: center;
  border-radius: 0px;
  padding: 10px 0;
  z-index: 999;
}

.label-select {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.4);
}

.con-vs-chip {
  min-height: 0;
  float: none;
  display: inline-block;
}
.item-collapse {
  border-color: #cdcdcd;
}
.item-collapse .content {
  background: #f8f8f8;
  padding: 10px;
}
</style>
